import React, { memo } from 'react';
import classnames from 'classnames';
import Element from '../../element';
import { POSITION } from '@zmedia/bm-soccer-ui/constants';
import styles from './level.module.scss';

interface IProps {
    className?: string;
    children: React.ReactNode;
    align?: POSITION;
    domRef?: any;
}

function LevelSide(props: IProps) {
    const { className, children, align, ...rest } = props;
    return (
        <Element
            {...rest}
            className={classnames(className, {
                [styles[`level-${align}`]]: align,
            })}
        >
            {children}
        </Element>
    );
}

export default memo(LevelSide);
